export default class Icon {
    constructor(element) {
        this.element = element;
        this.src = element.attributes.getNamedItem('data-src')?.nodeValue ?? element.attributes.getNamedItem('src').nodeValue;
        this.color = element.attributes.getNamedItem('data-color')?.nodeValue ?? '';
        this.alt = element.attributes.getNamedItem('data-alt')?.nodeValue ?? element.attributes.getNamedItem('alt').nodeValue;
        this.width = element.attributes.getNamedItem('data-width')?.nodeValue ?? '';

        this.wrapper = document.createElement('div');
        this.wrapper.classList = element.classList

        this.setSvg()
    }

    setSvg(){
        if (this.src === '') return;
        fetch(this.src)
            .then(response => {
                if(response.status >= 400){
                    console.error('SVG asset is not defined: ' + response.statusText);
                    return '';
                }
                return response.text()
            })
            .then(data => {
                if(typeof data !== "string"){
                    return;
                }
                let container = document.createElement('div');
                container.innerHTML = data
                let svg = container.querySelector('svg')
                if(svg !== null){
                    this.wrapper.innerHTML = svg.outerHTML
                }

            })
            .then(() => this.applyConfig())
            .then(this.element.replaceWith(this.wrapper))
    }

    applyConfig() {
        if(this.color !== '') {
            /* Iterate all tags containing path information to change color all layers */
            let nodes = this.wrapper.querySelectorAll('path,rect,polygon,circle')
            for(let node of nodes){
                node.setAttribute('style', `fill: ${this.color}`);
            }
        }
        let svg = this.wrapper.querySelector('svg');
        if(svg === null) return;
        if(this.width !== '') {
            svg.style.width = this.width;
        }
        svg.setAttribute('aria-label', this.alt);
    }

}
